import _taggedTemplateLiteral from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import styled from 'styled-components';
import { mediaMin } from '@spa/shared/theme';
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1xy9fw7-0"
})(["display:flex;flex-direction:column;", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(5, 'column');
});
export var Title = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-1xy9fw7-1"
})(["font-size:", ";line-height:", ";font-weight:600;color:", ";"], function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, function (props) {
  return props.theme.overview.aboutThisPlace.text.color;
});
export var Subtitle = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-1xy9fw7-2"
})(["font-size:", ";line-height:", ";font-weight:600;color:", ";"], function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.overview.aboutThisPlace.text.color;
});
export var LivingWith = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1xy9fw7-3"
})(["display:flex;flex-wrap:wrap;font-size:", ";line-height:", ";", ";color:", ";div{display:flex;", ";}", " svg{width:24px;height:22px;.st1{fill:", ";}}"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(20);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(6);
}, function (props) {
  return props.theme.overview.aboutThisPlace.text.color;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.gap(2);
}, mediaMin.mediumBreakpoint(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.gap(3);
}), function (props) {
  return props.theme.overview.aboutThisPlace.roommatesIcon.fill;
});